<template>
  <div v-loading="loading">
    <div>
      <svg-icon icon-class="contract-agreement" />
      <el-tooltip class="item" effect="dark" content="Contract Monthly Agreement" placement="right">
        <p style="text-transform: capitalize; cursor:pointer;" @click="showForm('monthly')">
          <el-tag style="margin-right: 5px"
            :type="contract_check.monthly_fee && contract_check.monthly_fee.status === 'active' ? 'success' : 'danger'">
            Contract Monthly: <b>{{ contract_check.monthly_fee.status === 'active' ? 'ON' : 'OFF' }}</b>
          </el-tag>
        </p>
      </el-tooltip>
    </div>
    <div>
      <svg-icon icon-class="contract-agreement" />
      <el-tooltip class="item" effect="dark" content="Contract Compliance Agreement" placement="right">
        <p style="text-transform: capitalize; cursor:pointer;" @click="showForm('compliance')">


          <el-tag
            :type="contract_check.compliance_fee && contract_check.compliance_fee.status === 'active' ? 'success' : 'danger'">
            Contract Compliance: <b>{{ contract_check.compliance_fee.status === 'active' ? 'ON' : 'OFF' }}</b>
          </el-tag>
        </p>
      </el-tooltip>
    </div>

    <el-dialog :title="titleCreate" :close-on-click-modal="false" :visible.sync="dialogCreateFormVisible"
      append-to-body>
      <el-form ref="contractForm" :model="formData" label-width="220px" :rules="formDataRules">

        <el-form-item label="Bankholder ID" prop="bankholderID">
          <el-select v-model="formData.bankholderID" placeholder="Please select bankholderID" style="width:100%">
            <el-option v-for="item in bankAccounts" :key="item.uid"
              :label="`(${item.currency.toUpperCase()}) ${item.bankholderID}`" :value="item.bankholderID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Contract Duration (Months)" prop="durationMonths">
          <el-input-number v-model="formData.durationMonths" controls-position="right" :min="1"
            :max="120"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCreateFormVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="submiting" @click="submitCreateForm">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="titleRenew" :close-on-click-modal="false" :visible.sync="dialogUpdateFormVisible"
      append-to-body>
      <div v-loading="loading_balance">
        <el-form ref="contractUpdateForm" :model="updateFormData" label-width="220px" :rules="formDataRules">
          <div v-if="activeContractInfo" style="margin-bottom: 15px; padding-left: 20px;">
            <p><strong>Status: </strong> <el-tag type="success" size="mini" style="text-transform: capitalize;">{{
              activeContractInfo.status }}</el-tag></p>
            <p><strong>Total Amount: </strong> {{ activeContractInfo.total_amount }} {{ activeContractInfo.currency ?
              activeContractInfo.currency.toUpperCase() : '' }}</p>
            <p><strong>Duration: </strong> {{ activeContractInfo.duration_months }} Months</p>
            <div v-if="activeContractInfo.last_state">
              <p><strong>Current Balance: </strong> {{ activeContractInfo.last_state.balance }}</p>
              <p><strong>Description: </strong> {{ activeContractInfo.last_state.description }}</p>
            </div>
          </div>
          <el-form-item label="Extension Duration (Months)" prop="durationMonths">
            <el-input-number v-model="updateFormData.durationMonths" controls-position="right" :min="1"
              :max="120"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogUpdateFormVisible = false">Cancel</el-button>
          <el-button type="primary" :loading="submiting" @click="submitUpdateForm">Confirm</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { checkContractAvailability, getContractBalance, createContract, renewContract } from "@/api/customer";
import { getBankAccountByCustomer } from "@/api/bank-account";
export default {
  name: "ConctractForm",
  props: {
    customerUID: String
  },
  computed: {
    activeContractInfo() {
      if (!this.contract_balance) return null;
      return this.contract_balance[this.formType] || this.contract_balance[`${this.formType}_fee`];
    }
  },
  data() {
    return {
      loading: false,
      loading_balance: false,
      submiting: false,
      dialogCreateFormVisible: false,
      dialogUpdateFormVisible: false,
      titleCreate: "",
      titleRenew: "",
      formType: "monthly", //or "compliance"
      bankAccounts: [],
      contract_check: {
        "monthly_fee": {
          "can_create": false,
          "status": "active"
        },
        "compliance_fee": {
          "can_create": true,
          "status": "inactive"
        }
      },
      contract_balance: {
        "monthly": null,
        "compliance": null
      },
      formData: {
        "durationMonths": 6,
        "bankholderID": "",
        "type": "monthly" // or "compliance"
      },
      updateFormData: {
        "contractUID": "",
        "durationMonths": 6
      },
      formDataRules: {
        "durationMonths": [
          { required: true, message: "Please enter mounthly duration", trigger: "blur" },
          { type: "number", min: 1, max: 120 }
        ],
        "bankholderID": [
          { required: true, message: "Please select bankholderID", trigger: "blur" },
        ],
      },
    }
  },
  methods: {
    checkContractAvailability(cb) {
      this.loading = true;
      checkContractAvailability(this.customerUID).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.contract_check = data;
        }
        if (typeof cb === 'function') {
          cb()
        }
      });
    },
    getBankAccounts() {
      getBankAccountByCustomer(this.customerUID).then(({ result, data }) => {
        if (result && data) {
          this.bankAccounts = data.filter(item => item.status === 'active');
        }
      });
    },
    getBalance(cb) {
      this.loading_balance = true;
      getContractBalance(this.customerUID).then(({ result, data }) => {
        this.loading_balance = false;
        if (result && data) {
          this.contract_balance = data;
        }
        if (typeof cb === 'function') {
          cb()
        }
      });
    },
    showForm(type) {
      this.formType = type;
      this.formData.type = type;
      this.formData.bankholderID = "";
      this.updateFormData.contractUID = "";
      this.updateFormData.durationMonths = 6;
      this.dialogCreateFormVisible = false;
      this.dialogUpdateFormVisible = false;
      this.titleCreate = `Create Contract ${type === 'monthly' ? 'Monthly' : 'Compliance'} Agreement`;
      this.titleRenew = `Renew Contract ${type === 'monthly' ? 'Monthly' : 'Compliance'} Agreement`;
      this.checkContractAvailability(() => {
        if (this.contract_check[`${type}_fee`].can_create) {
          this.getBankAccounts();
          this.dialogCreateFormVisible = true;
        } else {
          this.dialogUpdateFormVisible = true;
          this.getBalance(() => {
            const info = this.contract_balance[type] || this.contract_balance[`${type}_fee`];
            if (info) {
              this.updateFormData.contractUID = info.contract_uid;

            }
          });

        }
      });

    },
    submitCreateForm() {
      this.$refs.contractForm.validate((valid) => {

        if (valid) {
          this.$confirm('Are you sure you want to make contract agreement, Continue?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            this.submiting = true;
            createContract(this.formData).then(({ result, message }) => {
              this.submiting = false;
              if (result) {
                this.$notify({
                  title: "Success",
                  message: message,
                  type: "success",
                  duration: 2000
                });
                this.checkContractAvailability();
                this.dialogCreateFormVisible = false;
              }
            })
          }).catch(() => {
            this.submiting = false;
          });
        }
      });
    },
    submitUpdateForm() {
      this.$refs.contractUpdateForm.validate((valid) => {
        if (valid) {
          this.$confirm('Are you sure you want to renew contract agreement, Continue?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            this.submiting = true;
            renewContract(this.updateFormData).then(({ result, message }) => {
              this.submiting = false;
              if (result) {
                this.$notify({
                  title: "Success",
                  message: message,
                  type: "success",
                  duration: 2000
                });
                this.checkContractAvailability();
                this.dialogUpdateFormVisible = false;
              }
            })
          }).catch(() => {
            this.submiting = false;
          });
        }
      });
    }
  },
  mounted() {
    this.checkContractAvailability();
  }
}
</script>

<style lang="scss" scoped></style>